// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__17KG3","title":"AfterFrontImage_title__SB6HU"};